export const TOUCHSTONE_SYSTEMS = {
  FEATURE_SET: "feature_set",
  MODEL_REFRESH: "model_refresh",
};

export const TOUCHSTONE_SUBMISSIONS_STATUS = {
  ACCEPTED: "ACCEPTED",
  CANCELED: "CANCELED",
  CANCELING: "CANCELING",
  ERROR: "ERROR",
  QUEUED: "QUEUED",
  REJECTED: "REJECTED",
  SUBMITTED: "SUBMITTED",
  SUCCESS: "SUCCESS",
  VALIDATING: "VALIDATING",
  VALIDATION_ERROR: "VALIDATION_ERROR",
};

export const TOUCHSTONE_TASKS_STATUS = {
  DEPLOYING: "DEPLOYING",
  ERROR: "ERROR",
  FINISHED_CANCELED: "FINISHED_CANCELED",
  FINISHED_ERROR: "FINISHED_ERROR",
  FINISHED_SUCCESS: "FINISHED_SUCCESS",
  PENDING_CANCEL: "PENDING_CANCEL",
  PREPARED: "PREPARED",
  PREPARING: "PREPARING",
  QUEUED: "QUEUED",
  SUCCESS: "SUCCESS",
  TRAINING: "TRAINING",
};

export const TOUCHSTONE_TASKS_ACTIVE_STATUS = Object.values(TOUCHSTONE_TASKS_STATUS).filter((status) => !status.startsWith("FINISHED"));

export const TOUCHSTONE_TASKS_TYPES = {
  TRAINING: "TRAINING",
  VALIDATION: "VALIDATION",
  MODEL_REFRESH_REPORT: "MODEL_REFRESH_REPORT",
};

export const TOUCHSTONE_PLATFORMS = [
  { key: "ANY", description: "Anywhere (on-prem server or RunPod)" },
  { key: "ANY_SERVER", description: "Any on-prem server" },
  { key: "RUNPOD", description: "RunPod" },
];

export const GSI_PK = "ALL";

// given the contents of the SystemConfig DB, return an array of on-prem server names, and a mapping
// from server names to that server's attributes
export const onPremServerInfoFromSystemConfigs = (systemConfigs) => {
  const serverEntries = systemConfigs.filter((c) => c.category === "touchstone-servers");
  // each entry contains a keyname in the format <serverIndentifier>.<field> where <field> is
  // e.g. gpu_type, num_slots. Reorganize it into an object with one attribute per server.
  const entriesByServer = {};
  serverEntries.forEach((e) => {
    const match = e.keyname.match(/^([^.]*)\.(.*)/);
    const serverName = match[1];
    const attributeName = match[2];
    if (!entriesByServer[serverName]) {
      entriesByServer[serverName] = {};
    }
    entriesByServer[serverName][attributeName] = e.value;
  });
  const serverNames = Object.getOwnPropertyNames(entriesByServer);
  serverNames.sort();
  return { names: serverNames, attributes: entriesByServer };
};
